export const upperCaseFirstLetter = string => {
    const words = string.split(' ');
    return words
        .map(word => {
            const w = word.toLowerCase();
            return `${w[0].toUpperCase()}${w.slice(1)}`;
        })
        .join(' ');
}
